/**
 * Specifies the CSS class that will be applied to the row of the timeline area
 * @param instance
 * @returns {function(*, *, *): string}
 */
export default instance => (start, end, task) => {
  let css = '';

  if (task.type === instance.config.types.button) {
    css += ' gantt_button';
  }

  if (task.$level === 0) {
    css += ' gantt_estimate_total_row';
  }

  if (task.$level === 1 && task.type !== 'task') {
    css += ' gantt_top_project_row';
  }

  if (instance.isSelectedTask(task.id) || instance.getState().selected_task === task.id) {
    css += ' gantt_selected';
  }

  return css;
};
